// Fixed category for the two built-in, dosage-calculated medicines. "Other"
// medicine names each carry their own category (set in Settings).
export const BUILT_IN_MEDICINE_CATEGORY = { paracetamol: 'Painkillers', ibuprofen: 'Painkillers' };

// One source of truth for what colour each medicine is, so a bar in the
// Calculator's 24-hour tracker and a marker on the Records/Temperature timeline
// read as the same medicine. `hex` feeds the hand-rolled SVG chart; the Tailwind
// classes feed the DOM bars — same colour either way.
//
// A medicine keeps its colour regardless of how full its bar is: a bar that
// turned red near the daily limit would stop being a reliable "which medicine is
// this?" cue, which is the point of showing the two side by side. Limit warnings
// ride on the numbers instead. "Other" is green, which is why the painkillers
// avoid the teal/emerald end of the range.
export const MED_COLORS = {
  paracetamol: { hex: '#3b82f6', bar: 'bg-blue-500',   pending: 'bg-blue-300' },
  ibuprofen:   { hex: '#8b5cf6', bar: 'bg-violet-500', pending: 'bg-violet-300' },
};
export const OTHER_MED_COLOR = { hex: '#10b981', hexDark: '#34d399' };

// Plausible range for a logged reading, shared by the Temperature form and the
// Records editor so a correction is validated the same way as an original entry.
export const TEMP_MIN = 34, TEMP_MAX = 43;

// KKH (KK Women's and Children's Hospital, Singapore) fever advice, used for the
// Calculator's hint line: paracetamol 4-hourly above 38.5 °C, 6-hourly below;
// ibuprofen only when the fever stays above 38.5 °C, 1–2 h after paracetamol.
// The hint's "KKH" links to this page, so the source is one tap away.
export const KKH_FEVER_URL = 'https://www.singhealth.com.sg/symptoms-treatments/fever-childhood-illnesses';
export const KKH_FEVER_THRESHOLD_C = 38.5;
export const KKH_HINT_MAX_AGE_HOURS = 4; // older readings don't describe the fever now

// Timeline chart ranges, in days, ascending — the order matters, since the
// chart's default range is the first one wide enough to hold all the data.
export const CHART_RANGES = [0.5, 1, 2, 3, 5, 7];
export const chartRangeLabel = (d) => d === 0.5 ? '12h' : d === 1 ? '24h' : d === 2 ? '48h' : `${d}d`;

// How far back the Records list reaches, in days (0 = no limit). It opens on the
// last week: after a few months of use the list is mostly history nobody is
// looking at, and this morning's dose is what you actually came for. Everything
// older is one change of the Date Range filter away — nothing is deleted, and
// Export keeps its own independent range.
export const RECORDS_RANGE_OPTIONS = [1, 3, 7, 14, 30, 90, 0];
export const RECORDS_DEFAULT_DAYS = 7;
export const recordsRangeLabel = (d) =>
  d === 0 ? 'All time' : d === 1 ? 'Last 24 hours' : `Last ${d} days`;

// Time constants
export const HOURS_IN_DAY = 24;
export const MS_PER_HOUR = 3600000;
export const MS_PER_DAY = HOURS_IN_DAY * MS_PER_HOUR;
